{
  "name": "clientwebsite",
  "version": "0.0.0",
  "license": "MIT",
  "angular-cli": {},
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch",
    "build": "ng build",
    "test": "ng test",
    "unit-test": "set TS_NODE_PROJECT=tsconfig.mocha.json&& mocha",
    "pree2e": "webdriver-manager update --standalone false --gecko false",
    "e2e": "protractor",
    "lint": "ng lint --max-warnings=0",
    "check-audit": "check-audit"
  },
  "overrides": {
    "qa": ">=6.14.1",
    "serialize-javascript": "7.0.3"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.18",
    "@angular/common": "20.3.18",
    "@angular/compiler": "20.3.18",
    "@angular/core": "20.3.18",
    "@angular/forms": "20.3.18",
    "@angular/localize": "20.3.18",
    "@angular/platform-browser": "20.3.18",
    "@angular/platform-browser-dynamic": "20.3.18",
    "@angular/router": "20.3.18",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@sentry/angular": "^10.23.0",
    "@types/chai": "^4.3.0",
    "@types/chart.js": "^2.9.41",
    "@types/jquery": "^3.5.32",
    "@types/mocha": "^10.0.10",
    "@types/pako": "^2.0.3",
    "chart.js": "^4.5.1",
    "font-awesome": "4.7.0",
    "jquery": "^3.7.1",
    "lodash.orderby": "^4.6.0",
    "ng2-charts": "9.0.0",
    "npm-audit-resolver": "^3.0.0-RC.0",
    "pako": "^2.1.0",
    "rxjs": "^7.8.2",
    "tsconfig-paths": "^3.14.0",
    "tslib": "^2.8.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.24",
    "@angular-eslint/builder": "20.5.1",
    "@angular-eslint/eslint-plugin": "20.5.1",
    "@angular-eslint/eslint-plugin-template": "20.5.1",
    "@angular-eslint/schematics": "20.5.1",
    "@angular-eslint/template-parser": "20.5.1",
    "@angular/cli": "20.3.24",
    "@angular/compiler-cli": "20.3.18",
    "@sentry/cli": "^2.42.2",
    "@types/lodash.orderby": "^4.6.6",
    "@typescript-eslint/eslint-plugin": "8.46.3",
    "@typescript-eslint/parser": "8.46.3",
    "chai": "^4.3.10",
    "eslint": "9.39.1",
    "mocha": "^10.8.2",
    "source-map-support": "^0.5.21",
    "tar": "7.5.11",
    "ts-node": "^10.9.2",
    "typescript": "~5.8.2",
    "zone.js": "^0.15.1"
  }
}